import { NoteTemplateShareInfo, TemplateShareSource } from '../types'

export const filterGeneralAccessInfo = (
  shares?: Array<NoteTemplateShareInfo>
) => {
  return shares?.find(
    (share) => share.entity_type === TemplateShareSource.TENANT
  )
}
